var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClass},[_c('label-text',{attrs:{"label":_vm.label}}),_c('input-number',{attrs:{"disableStatus":_vm.disableStatus,"set":_vm.set},model:{value:(_vm.get),callback:function ($$v) {_vm.get=$$v},expression:"get"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }